import { FieldArray } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { InputWithHelp, Help } from 'libs/ui';
import { FieldComponent, Toggle } from 'libs/form';
import { ZoneInputBox } from '../../../styled';
import { IntervalSimpleInputs } from './interval-simple-inputs';
import { Header, Headers, Content, Input, ZoneLabel } from './interval-simple.styled';

export const IntervalSimple = ({ disabled, zone }) => {
  const { t } = useTranslation();
  const withFreeperiod = true;

  /**
   * get fields
   * @param {*} extended
   * @returns
   */
  const getFields = () => {
    const k = 1.2; //window.innerWidth < 1450 ? 1.2 : 1.7;
    const fields = [
      { w: 145 * k, title: t('grid.Время начала периода'), $center: true },
      { w: 130 * k, title: t('grid.Стоимость за период'), right: true },
    ];
    // fields.push({ title: '' });
    return fields;
  };
  const fields = getFields();

  return (
    <Content>
      <Headers>
        {fields.map((el, idx) => {
          const { title, ...rest } = el;
          return (
            <Header {...rest} key={idx}>
              {title}
            </Header>
          );
        })}
      </Headers>

      <FieldArray name="intervals" component={IntervalSimpleInputs} disabled={disabled} tableFields={fields} zone={zone} />

      {withFreeperiod && (
        <div style={{ paddingTop: '30px' }}>
          <InputWithHelp>
            <Toggle className="black" label={t('form.Тарификация бесплатного времени')} name="use_freeperiod" type="toggle" disabled={disabled} />
            <Help className="white" info={t('tariffs.Тарификация бесплатного времени помощь интервальный')} />
          </InputWithHelp>
          <InputWithHelp>
            <Input>
              <ZoneLabel>{t('form.Бесплатное время')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent
                  type="text"
                  name="free_interval"
                  title={t('form.Бесплатное время')}
                  naturalNumber
                  withZero
                  maxValueLength={5}
                  disabled={disabled}
                  mask={{ suffix: t('form.мин') }}
                />
              </ZoneInputBox>
            </Input>
            <Help
              style={{
                marginTop: '40px',
              }}
              w="auto"
              className="white nowrap"
              info={t('tariffs.Бесплатное время помощь интервальный')}
            />
          </InputWithHelp>
        </div>
      )}
    </Content>
  );
};
